import { parseLegacyId } from '@/shared/lib/legacy-id';
import type { Banner } from '@/shared/types/banner';
import { normalizeBannerUrl } from './banner-image';

/** Documento banner na legacy-api (Mongo em passbooks.banners). */
export interface LegacyBanner {
  _id?: unknown;
  banner: string;
  title?: string;
  description?: string;
  entryDate?: string | null;
  exitDate?: string | null;
  active?: boolean;
  order?: number | null;
  url?: string;
  expiry?: boolean;
}

export function mapLegacyBanner(row: LegacyBanner): Banner {
  return {
    _id: parseLegacyId(row._id),
    banner: normalizeBannerUrl(row.banner ?? ''),
    title: row.title,
    description: row.description,
    entryDate: row.entryDate,
    exitDate: row.exitDate,
    active: row.active ?? true,
    order: row.order == null ? undefined : Number(row.order),
    url: row.url,
    expiry: row.expiry,
  };
}
